<p-scrollPanel [style]="{height: 'calc(75vh)'}">
    <div class="add-employee-text add-employee-subheader mb-5 mt-3">Add an Employee</div>
    <div class="add-employee-text add-employee-description mb-6 w-50">
        Build your team on Xpress! Add staff members and assign their roles to help manage orders, 
        update menus, and keep your business running smoothly on our platform.
    </div>
    <button class="add-btn" mat-button color="primary" (click)="addEmployee()">
        <span>Add Employee</span>
        <mat-icon class="ml-2">arrow_forward</mat-icon>
    </button>
</p-scrollPanel>
<img class="add-employee-img" src="/XpressApp/assets/images/store/create-employees-image.png" />